import { JamfSyncState } from './types';

export const INITIAL_STATE: () => JamfSyncState = () => {
  return {
    runId: '',
    initialized: false,
    stats: {
      synced: 0,
      unsynced: 0,
    },
    createdAt: '',
    processing: false,
    loadingState: 'idle',
    getLastSyncLoading: 'idle',
  };
}; 
